export default "__VITE_ASSET__xWthEEPK__"